module.exports = __webpack_public_path__ + "media/images/countryrect/gw-aac04a92e71fd7e7b127dde89ad2fcfb.svg";